/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

import Login from "./pages/Login/Login";
import SideBar from "./components/SideBar/SideBar";
import TopBar from "./components/TopBar/TopBar";
import Footer from "./components/Footer/Footer";
import { routes } from "./constants/routes";
import SubHeader from "./components/SubHeader/SubHeader";
import { ROUTER } from "./constants/env";
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      authenticated: localStorage.getItem("token"),
    };
  }
  render() {
    return this.state.authenticated ? (
      <BrowserRouter>
        <div classNam="d-flex flex-column flex-root">
          <div className="d-flex flex-row flex-column-fluid page">
            <SideBar />
            {/*<!--begin::Wrapper-->*/}
            <div
              className="d-flex flex-column flex-row-fluid wrapper"
              id="kt_wrapper"
            >
              <TopBar />

              <SubHeader />

              <Switch>
                {routes.map((elem, index) => {
                  return (
                    <Route
                      key={index}
                      path={elem.path}
                      exact={elem.exact}
                      component={elem.main}
                    />
                  );
                })}
                <Redirect to={ROUTER.ERROR} />
              </Switch>
              <Footer />
            </div>
            {/*<!--end::Wrapper-->*/}
          </div>
        </div>
      </BrowserRouter>
    ) : (
      <div
        id="kt_body"
        class="header-fixed header-mobile-fixed subheader-enabled subheader-fixed subheader-mobile-fixed aside-enabled aside-fixed aside-minimize-hoverable page-loading"
      >
        <BrowserRouter forceRefresh={true}>
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route render={() => <Redirect to="/login" />} />
          </Switch>
        </BrowserRouter>
      </div>
    );
  }
}

export default App;
